import "./tooltip.scss"

import PropTypes from "prop-types"
import React from "react"

export default function TableTooltip({
  children,
  tooltipText = "",
  showTooltip = false,
  position = "right"
}) {
  if (!showTooltip) return children
  return (
    <div className="table-tooltip-wrapper">
      {children}
      <div className={`table-tooltip-container bg-white ${position}`}>
        <div className={`table-tooltip-text ${position}`}>{tooltipText}</div>
      </div>
    </div>
  )
}

TableTooltip.propTypes = {
  children: PropTypes.node,
  tooltipText: PropTypes.node,
  showTooltip: PropTypes.bool,
  position: PropTypes.string
}
